import React from 'react';
import './CanProducePopup.css'; // Create or reuse a CSS file for popup styling

const CanProducePopup = ({ sku, canProduce, bagsAvailable, seedsAvailable, onClose }) => {
  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <h2>Can be Produce for SKU: {sku}</h2>
        <div className="popup-details">
          <p><strong>Can Produce:</strong> {Number(canProduce).toLocaleString()} units</p>
          <p><strong>Bags Available:</strong> {Number(bagsAvailable).toLocaleString()} units</p>
          <p><strong>Seeds Available:</strong> {Number.isFinite(Number(seedsAvailable)) ? Number(seedsAvailable).toFixed(2) : '0.00'} lb</p>
        </div>
        <button className="popup-close-btn" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

export default CanProducePopup;